import { useState } from "react";
import { post } from "../networking/RequestService";
import useGetProfile from "./useGetProfile";

const useProfilKaydet = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const { refetch: getProfile } = useGetProfile();

    const profilKaydet = async (params) => {
        setLoading(true);
        setError(null);

        try {
            const payload = {
                fn: "profilKaydet",
                ad: params.ad,
                soyad: params.soyad,
                baslik: params.baslik,
                headline: params.headline,
                sirket: params.sirket,
                tel: params.tel,
                email: params.email,
                city: params.city,
                country: params.country,
                resim: params.resim,
                url: params.url,
                kategori: params.kategori,
                auto: params.auto,
                isManuel: params.isManuel,
                id: params.id ? params.id : null,
            };

            const response = await post(payload);

            if (response && response.data) {
                setData(response.data);
                getProfile();
                return response.data;
            }

            return null;
        } catch (err) {
            setError(err);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        error,
        data,
        profilKaydet,
    };
};

export default useProfilKaydet;
